import BaseApi from './baseApi'
import store from "@/store";

 class Api {

     login(user) {
         return BaseApi({requiresAtuh: false})({
             method: 'POST',
             data: JSON.stringify(user),
             url: '/public/login',
             headers: {'Content-Type': 'application/json'},
         }).then(response => {
             if(response && response.status===200) {
                 store.commit('createSession', response)
                 return response;
             }
         })
     }

     logout() {
         // localStorage.removeItem('user');
         store.commit('destroySession')
     }


    delete(entity,id) {
        return BaseApi({requiresAtuh: true})({
            method: 'DELETE',
            url: '/private/'+entity+'/delete/?id='+id,
            headers: {'Content-Type': 'application/json'},
        })
    }
    new_(entity) {
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/'+entity+'/new',
            headers: {'Content-Type': 'application/json'},
        })
    }
 getById(entity,id) {
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/'+entity+'/edit/?id='+id,
            headers: {'Content-Type': 'application/json'},
        })
    }
    getPage(entity,page_,size_) {
        var formData = new FormData();
        formData.set("page",page_)
        formData.set("size", size_)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+entity+'/list/',
            headers: {'Content-Type': 'application/json'},
        })
    }

    save(entity,model) {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: model,
            url: '/private/'+entity+'/save/',
            headers: {'Content-Type': 'application/json'},
        })
    }

}

export default new Api();
